import { PdfSearchMatch } from "./pdfSearch";

export type MatchHighlightBox = {
  left: number;
  top: number;
  width: number;
  height: number;
};

const getTextNode = (element: HTMLElement): Text | null => {
  if (element.firstChild?.nodeType === Node.TEXT_NODE) {
    return element.firstChild as Text;
  }
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  return (walker.nextNode() as Text | null) || null;
};

export const getMatchHighlightBoxes = (
  pageWrap: HTMLElement | null,
  textDivs: HTMLElement[] | undefined,
  match: PdfSearchMatch
): MatchHighlightBox[] => {
  if (!pageWrap || !textDivs?.length) return [];

  const textDiv = textDivs[match.itemIndex];
  if (!textDiv) return [];

  const textNode = getTextNode(textDiv);
  if (!textNode?.textContent) return [];

  const textLength = textNode.textContent.length;
  const start = Math.min(match.charStart, textLength);
  const end = Math.min(match.charEnd, textLength);
  if (start >= end) return [];

  try {
    const range = document.createRange();
    range.setStart(textNode, start);
    range.setEnd(textNode, end);

    const wrapRect = pageWrap.getBoundingClientRect();
    return Array.from(range.getClientRects())
      .filter((rect) => rect.width > 0 && rect.height > 0)
      .map((rect) => ({
        left: rect.left - wrapRect.left + pageWrap.scrollLeft,
        top: rect.top - wrapRect.top + pageWrap.scrollTop,
        width: rect.width,
        height: rect.height
      }));
  } catch {
    return [];
  }
};

export const getMatchScrollTop = (
  pageContainer: HTMLElement | null,
  boxes: MatchHighlightBox[]
): number | null => {
  if (!pageContainer || !boxes.length) return null;
  return Math.max(0, pageContainer.offsetTop + boxes[0].top - 40);
};
